// IE 2026 10 07 / ODOO-5800: ГАСИМАЯ ЯЧЕЙКА строки отчёта DL2 — опция поля строки раскладки «Hidden» (приховано) значит «в строках ЭТОГО уровня ячейка этого поля пуста»,
// даже когда тот же binding виден на другом уровне и его колонка общая (отчёт «Мережевий шар»: Grade виден на уровне B, скрыт на C — у строк C в колонке «Ступінь»
// стояла пилюля «Погано»; колонки собираются один раз на весь отчёт и дедуплицируются по binding, а значение каждая строка кладёт в колонку из СВОЕГО dataItem).
// Контракт с бэком (закреплён, бэк кладёт ровно это): у строки DL2 `_DLRow.cells[<binding>].blank === true` — тот же контейнер меты ячейки, где бэк (_direction_pass)
// держит `_DLRow.cells[<binding>].dir`. Значение В dataItem ОСТАЁТСЯ: условное оформление СОСЕДНИХ ячеек строки и drill-down читают его; гасится только ПОКАЗ —
// ячейка выглядит как ячейка строки БЕЗ значения по этому binding: ни текста, ни пилюли статуса, ни оформления САМОЙ ячейки (условное оформление, мета бэка, стрелка
// Direction), пуста в выгрузке XLSX / CSV / PDF, при копировании и в подсказке. Здесь — чистая логика без Vue (юнит — tests/unit/dl2CellBlank.test.mjs);
// выключатель fe.ux.dl2HiddenBlank (дефолт ВКЛ) — в AttrGrid.dl2Blank_on.

// ячейка (строка, binding) погашена? Только явное `blank === true` из меты строки; нет _DLRow / cells / записи по binding — нет
export function dl2_cellBlank(dataItem, binding) {
    const cells = dataItem && dataItem._DLRow && dataItem._DLRow.cells
    if (!cells || binding === undefined || binding === null || binding === '') return false
    const m = cells[binding]
    return !!m && m.blank === true
}

// погашена ли ячейка (r, c) панели wijmo: строка панели → dataItem, колонка (индекс или имя / binding) → binding. Любая неожиданность — «нет»
export function dl2_panelCellBlank(panel, r, c) {
    try {
        const row = panel && panel.rows && panel.rows[r]
        const di = row && row.dataItem
        if (!di || !di._DLRow || !di._DLRow.cells) return false
        const cols = panel.columns
        const col = typeof c === 'number' ? (cols && cols[c]) : (cols && typeof cols.getColumn === 'function' ? cols.getColumn(c) : null)
        return !!col && dl2_cellBlank(di, col.binding)
    } catch (e) {
        return false
    }
}

// корень «пусто везде, где wijmo читает значение»: getCellData панели ячеек (текст ячейки при отрисовке, выгрузка XLSX / CSV / PDF, getClipString, правка, поиск,
// объединение) у погашенной ячейки отдаёт то же, что у ячейки БЕЗ значения: '' (форматированное) / null (сырое). Одна обёртка на экземпляр панели, повторный вызов —
// no-op. isOn — выключатель (необязателен): выкл → обёртка отдаёт значение как есть. Возврат: true — обёртка поставлена
export function dl2_hookGetCellData(panel, isOn) {
    if (!panel || panel._dl2BlankHooked || typeof panel.getCellData !== 'function') return false
    const base = panel.getCellData
    panel._dl2BlankHooked = true
    panel.getCellData = function (r, c, formatted) {
        if (dl2_panelCellBlank(this, r, c) && (!isOn || isOn())) return formatted ? '' : null
        return base.call(this, r, c, formatted)
    }
    return true
}
